// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"51669a41","392":"b1ece18a","813":"4b56a237","915":"b6a00f61"}[chunkId] + ".chunk.js";
};